module.exports = __webpack_public_path__ + "static/media/search.35fce55d.svg";